module.exports = __webpack_public_path__ + "img/banner-1-m.ef45d3e6.jpg";